import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WebStorageModule } from 'ngx-store-9';
import { FooterComponent, OutdatedComponent, ErrorHeaderComponent, HeaderComponent, MobileHeaderComponent, } from './@theme/index';
// Import your library
// import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ClickOutsideModule } from "ng-click-outside";
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { PdfViewComponent } from './@theme/components/pdf-view/pdf-view.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WebStorageModule,
    HttpClientModule,
    // SlickCarouselModule,
    ClickOutsideModule, RouterModule
  ],
  declarations: [
    FooterComponent,
    OutdatedComponent,
    ErrorHeaderComponent,
    HeaderComponent,
    MobileHeaderComponent,
    PdfViewComponent
  ],
  exports: [
    FormsModule,
    FooterComponent,
    OutdatedComponent,
    WebStorageModule,
    ErrorHeaderComponent,
    HeaderComponent,
    MobileHeaderComponent,
    PdfViewComponent,
    // SlickCarouselModule,
    ClickOutsideModule,
    RouterModule
  ],
})
export class SharedModule { }
